import { render } from "./Bloco.vue?vue&type=template&id=31410947"
import script from "./Bloco.vue?vue&type=script&lang=js"
export * from "./Bloco.vue?vue&type=script&lang=js"

import "./Bloco.vue?vue&type=style&index=0&id=31410947&lang=css"

import exportComponent from "C:\\Users\\Vinicius\\Desktop\\MyProject\\Vuejs3\\blog\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__